module.exports = __webpack_public_path__ + "static/media/pm.f9cee7ee.svg";